import React, { useEffect, useState } from 'react';
import { useWizard } from '../../wizard';
import { StepContainer, RadioGroup, NavigationButtons, InfoBox } from '../index';
import { contentApi } from '../../services/contentApi';
import { contentKeys } from '../../constants/contentKeys';

const PhotoMethodStep: React.FC = () => {
  const { selfServiceData, updateSelfServiceData, goNext, goBack } = useWizard();
  const [title] = useState('Hvor vil du få taget foto?');
  const [body, setBody] = useState<string[]>([]);

  useEffect(() => {
    contentApi.getByKey(contentKeys.pas.photo_method).then(c => {
      if (c?.body) {setBody(c.body || []);}
    });
  }, []);

  const handleChange = (value: string) => {
    updateSelfServiceData('photoMethod', value);
  };

  const handleNext = () => {
    if (selfServiceData.photoMethod) {
      goNext();
    }
  };

  const options = [
    { value: 'borgerservice', label: 'I Borgerservice' },
    { value: 'fotograf', label: 'Hos fotograf' },
    { value: 'medbring', label: 'Medbringer eget foto' },
  ];

  return (
    <StepContainer title="Hvor vil du få taget foto?">
      {body.length > 0 && (
        <InfoBox type="info">{body.map((p,i) => <p key={i}>{p}</p>)}</InfoBox>
      )}
      <RadioGroup
        name="photoMethod"
        options={options}
        value={selfServiceData.photoMethod}
        onChange={handleChange}
        legend="Hvor vil du få taget foto?"
        required={true}
      />
      <NavigationButtons
        onBack={goBack}
        onNext={handleNext}
        nextDisabled={!selfServiceData.photoMethod}
      />
    </StepContainer>
  );
};

export default PhotoMethodStep;
